import { SortableHandle } from "react-sortable-hoc";
import FeatherIcon from "../../common/FeatherIcon";

const DragHandle = SortableHandle(() => (
  <div className="uk-sortable-handle">
    <button
      className="uk-button hms-simple-icon-btn drag-handle"
      uk-tooltip="Move"
    >
      <FeatherIcon name="move" />
    </button>
  </div>
));

export default DragHandle;
